<!-- 探头详情 -->
<template>
    <div>
        <EditRelateDevice :show.sync="show" :forwardPlatform="forwardList" :carrier-id="carrierId" :units="units"
            :scopeId="scopeId" :carrierInfo="{ carrierType }"></EditRelateDevice>
    </div>
</template>

<script>
import EditRelateDevice from '@/pages/business/components/detail/carrierDetail/components/realteDevice/components/EditRelateDevice.vue';
import bus from '@/utils/bus';
import { shareForward, shareUnit } from '@/api/modules/carrier.js';
export default {
    components: {
        EditRelateDevice
    },
    data() {
        return {
            show: false,
            forwardList: [],
            units: [],
            scopeId: 0,
            carrierId: 0,
            carrierType: 0
        };
    },
    mounted() {
        // 提供sceneId carrierId probeCode carrierType
        bus.$on('probeParam', ({ sceneId, carrierId, probeCode, carrierType }) => {
            this.show = true;
            this.scopeId = sceneId;
            this.carrierId = carrierId;
            this.carrierType = carrierType;

            bus.$emit('probeDetailParam', { probeCode, carrierType });

        });
        this.getForward();
        this.getUnits();
    },
    methods: {
        getForward() {
            if (this.forwardList.length) {
                return;
            }
            // 获取转发平台
            shareForward().then(({ result }) => {
                this.forwardList = result;
            });
        },
        async getUnits() {
            if (!this.units.length) {
                const units = await shareUnit();
                this.units = units.result;
            }
        }
    },
    beforeDestroy() {
        bus.$off('probeParam');
    }
};
</script>
